import react,{Component} from 'react';
import { DKLabel, DKButton,showToast,TOAST_TYPE, DKSpinner,INPUT_TYPE,DKCalendar,DKIcon,DKIcons,DKLine,DKInput,INPUT_VIEW_DIRECTION,Toggle } from "deskera-ui-library";
import RouteManager from '../../../../managers/RouteManager';
import { FEDERAL_FREQUENCY } from '../../ReportsConstants';
import { DATE_FORMAT } from '../../../../constants/Constant';
import ReportService from '../../../../services/ReportService';
import { saveAs } from 'file-saver';
import { TENANT, TenantService } from '../../../../managers/TenantManagerService';
import moment from 'moment';
import { getCPFYears } from '../../../../managers/common/CommonUtil';
import PayrollService from '../../../../services/PayrollService';
export default class I9 extends Component{
    selectedYear = [0];
    selectedUser = [];
    isAdmin = TenantService.get(TENANT.IS_ADMIN);
    requiredFormat = DATE_FORMAT.YYYYMMDD;
    
    formType = 'I9'
    constructor(props){
        super(props)
        
        this.state = {
            year: getCPFYears(),
            canValidate:false,
            users:[]
        }
        if(this.isAdmin) {
            this.getUsers();
        }
    }
    componentDidMount() {
        RouteManager.setPresenter(this);
    }
    async getUsers(){
        const response = await PayrollService.getUsersList();
        if(response['status'] == 'OK') {
            
            this.setState({
                users:response['users'],
                
            })
        }
    }
    export(){
        this.setState({...this.state})
        let users = []
        let fileName = this.formType;
        if(this.isAdmin) {
            if(this.selectedUser.length == 0 || this.selectedYear.length ==0) {
                this.setState(
                    {
                        ...this.state,
                        canValidate:true
                    }
                )
                return
            }
            
            
            this.selectedUser.forEach(ind=>{
                users.push(this.state.users[ind].userId)
                fileName = `${this.state.users[ind].firstName}_${this.state.users[ind].lastName}_${this.formType}.pdf` 
            
            })
        } else {
            if( this.selectedYear.length ==0) {
                this.setState(
                    {
                        ...this.state,
                        canValidate:true
                    }
                )
                return
            }
            users.push(TenantService.get(TENANT.USER_ID));
            fileName = `${TenantService.get(TENANT.FIRST_NAME)}_${TenantService.get(TENANT.LAST_NAME)}_${this.formType}.pdf` 
        }
        
        ReportService.apiConfig = {
            year: this.state.year[this.selectedYear[0]]
        }
        ReportService.downloadForm(users,this.formType,{}).then(
            (response) => {
                
                saveAs(response,fileName);
            }, (error) => {
                showToast("Internal Server Error", TOAST_TYPE.FAILURE);
            }
        )
    }
    render(){
        return(
            <div className="parent-width">
                <DKLabel text="Form I-9" className="fw-m fs-l" />
                <div className="bg-white pb-l card-shadow mt-l">
                    <DKLabel text="Form I-9" className="fw-m fs-l p-l" />
                    <DKLine  className="bg-gray3  "/>
                    <div className="d-flex p-h-l">
                        { <div className="" style={{width:'35%'}}>
                        
                        <DKInput
                            title="Year"
                            value={this.selectedYear}
                            type={INPUT_TYPE.SELECT}
                            required={true}
                            canValidate={this.state.canValidate}
                            readOnly={false}
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            options={this.state.year}
                            errorMessage="Please select year"
                            onChange={(value)=>{
                               
                                this.selectedYear = value
                                this.setState({...this.state,canValidate:true})
                                
                            }}
                            />
                        </div>}
                        
                        {this.isAdmin && <div className="ml-l" style={{width:'35%'}}>
                        {(this.state.users.length === 0) && <div style={{marginLeft : "-348px", marginBottom : "-22px"}}><DKSpinner className="" /></div>}
                        <DKInput
                            title="Employee"
                            value={this.selectedUser}
                            type={INPUT_TYPE.SELECT}
                            required={true}
                            canValidate={this.state.canValidate}
                            readOnly={false}
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            options={this.state.users.map(res=>`${res.firstName} ${res.lastName}`)}
                            errorMessage="Please select employee"
                            onChange={(value)=>{
                                this.selectedUser = value
                            }}
                            />
                        </div>}

                        <div className={`mb-xs ${this.isAdmin ? 'mr-l': 'ml-l'}` } style={{marginTop: '25px'}}>
                            <DKButton
                            title="DOWNLOAD FORM"
                            icon={DKIcons.white.ic_download}
                            className={`bg-app text-white ${this.isAdmin ? 'ml-l': ''}` }
                            onClick={()=>{
                                this.export();
                            }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}